export enum FreelancerAccessErrorTypes {
    NO_ACCESS = 'NO_ACCESS',
    NO_DATA_PROVIDED = 'NO_DATA_PROVIDED'
}

export class FreelancerAccessError extends Error {
    public errorType: FreelancerAccessErrorTypes;
    public message: string;

    constructor(message: string, errorType: FreelancerAccessErrorTypes) {
        super();
        this.errorType = errorType;
        this.message = message;
    }
}
